<div class="contents-area layout_balance" (dragstart)="onDragstartBody($event)">
  <div class="block-column">
    <div>
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">表示モード</label>
          <div class="list-input-content">
            <app-radio-label label="基版コピー" id="rdb_KihanCopy" #rdb_KihanCopy name="rdb_DisplayMode"
              [subid]="'rdb_KihanCopy'" value="1" (change)="eventDisplayMode_CHANGEHandler()"
              [(ngModel)]="kymw2700Model.rdb_DisplayMode" [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
            <app-radio-label label="フェーズ管理" id="rdb_PhaseManage" #rdb_PhaseManage name="rdb_DisplayMode"
              [subid]="'rdb_PhaseManage'" value="2" (change)="eventDisplayMode_CHANGEHandler()"
              [(ngModel)]="kymw2700Model.rdb_DisplayMode" [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
          </div>
        </div>

        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txt_OrderCode" #txt_OrderCode [subid]="'txt_OrderCode'"
                [(ngModel)]="kymw2700Model.orderCode" [required]="true" [autofocus]="true"
                [catalogIDField]="txti_DelivCatalogId" (ngModelChange)="eventOrderCodeCHANGEHandler()"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-order-code-text-input>
            </div>

            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <app-plan-medium-type-combo-box id="cmb_MediumType" #cmb_MediumType [subid]="'cmb_MediumType'"
                [(ngModel)]="kymw2700Model.mediumType" [required]="true" [initAutoLoad]="false"
                [orderCode]="kymw2700Model.orderCode" [initFocusItem]="txt_OrderCode"
                (change)="eventMediumTypeCHANGEHandler()" [forcedEnabledMode]="'true'"
                [tabindex]="0"></app-plan-medium-type-combo-box>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="txti_DelivCatalogId" #txti_DelivCatalogId readonly/>
            </div>

            <label class="list-input-title">フェーズ</label>
            <div class="block-row">
              <div class="list-input-content">
                <input type="text" id="txti_Phase" #txti_Phase style="width: 27rem; height: 29px;"
                  [(ngModel)]="cmb_MediumType.selectedProgressWorkNumName" readonly/>
              </div>
            </div>
          </div>
        </div>
        <button id="btn_Display" #btn_Display class="btn-secondary" (click)="eventBtnDisplayCLICKHandler()"
          forcedEnabledMode="true" [tabindex]="0">表示</button>
      </div>
    </div>

    <!-- 表示モード：基版コピー -->
    <div class="element-row" id="kihan-buttons">
      <button id="btn_CheckKihanPage" #btn_CheckKihanPage class="btn-secondary"
        (click)="eventBtnCheckKihanPageCLICKHandler()" forcedEnabledMode="none" [tabindex]="0">基版ページをチェック</button>
      <button class="btn-secondary" id="btn_AllCopySelectedKihan" #btn_AllCopySelectedKihan
        (click)="exentBtnSelectedKihanCopyClickHandler()">選択基版を一括コピー</button>
    </div>

    <!-- 表示モード：フェーズ管理 -->
    <div id="phase-content">
      <h1>フェーズ管理</h1>
      <div class="block-row">
        <div class="element-row">
          <div class="column-list">
            <label class="list-input-title">確定フェーズ</label>
            <div class="list-input-content">
              <select class="combo-box-normal" id="cmb_FixationPhase" #cmb_FixationPhase
                [(ngModel)]="kymw2700Model.progressWorkNum" labelField="CodeValueName"
                (change)="eventFixationPhaseCHANGEHandler()" forcedEnabledMode="''" [tabindex]="0"
                [disabled]="kymw2700Model.cmbFixationPhaseDisabled">
                <ng-template ngFor let-item [ngForOf]="kymw2700Model.fixationPhaseList">
                  <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                </ng-template>
              </select>
            </div>
          </div>
          <div>
            <button id="btn_CheckAllPage" #btn_CheckAllPage class="btn-secondary"
              (click)="eventBtnCheckAllPageCLICKHandler()" forcedEnabledMode="'" [tabindex]="0">全ページをチェック</button>
          </div>
        </div>
        <div class="element-row">
          <div class="column-list">
            <label class="list-input-title">確定ボタン</label>
            <div class="list-input-content">
              <app-checkbox-label label="ロック解除" id="chk_FixationLockRelease" #chk_FixationLockRelease
                [subid]="'chk_FixationLockRelease'" [(ngModel)]="kymw2700Model.chkFixationLockSelectedMode"
                [disabled]="!kymw2700Model.chkFixationLockEnableMode" (change)="eventFixationLockCHANGEHandler()"
                [forcedEnabledMode]="''" [tabindex]="0"></app-checkbox-label>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">フェーズスキップ</label>
            <div class="list-input-content">
              <app-checkbox-label label="ロック解除" id="chk_PhaseSkipLockRelease" #chk_PhaseSkipLockRelease
                [forcedEnabledMode]="''" [tabindex]="0" [(ngModel)]="kymw2700Model.chkPhaseSkipLockFlag"></app-checkbox-label>
            </div>
          </div>
          <div>
            <button id="btn_Fixation" #btn_Fixation class="btn-secondary" (click)="eventBtnFixationCLICKHandler()"
              forcedEnabledMode="" [tabindex]="0">確定</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-container" style="height: calc(100vh - 135px); width: calc(100vw - 300px);">
    <wj-flex-grid id="dtg_KihanCopyList" #dtg_KihanCopyList [itemsSource]="kymw2700Model.kihanCopyList"
      [isReadOnly]="true" [allowSorting]="false" [allowDragging]="'None'" [headersVisibility]="'Column'"
      [deferResizing]="true" [selectionMode]="'Row'" forcedEnabledMode="" [tabindex]="0">
      <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'ページ番号'" [binding]="'PageNum'"
        [align]="'left'"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="125" [header]="'会員生協'" [binding]="'DiverFromCoopName'"
        [align]="'left'"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="1132" [header]="'ページ名称'" [binding]="'PageInfo'" [align]="'left'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [align]="'left'">{{cell.item.PageInfo}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'基版コピー'" [binding]="'isChecked'" [align]="'center'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="checkbox" id="cb_select_kihancopy_{{cell.row.index}}" #cb_select_kihancopy_{{cell.row.index}}
            (mouseup)="$event.stopPropagation()" [(ngModel)]="cell.item.isChecked"
            [disabled]="kymw2700Model.chkKihanCopyDisabled"/>
        </ng-template>
        <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
          <div class="all-kihancopy-checkbox">
            <label><input type="checkbox" id="all_Kihancopy_Check" #all_Kihancopy_Check [tabindex]="0"
              class="header-checkbox" (change)="eventKihanCopyAllCheck_CLICKHandler()" forcedEnabledMode=""
              [(ngModel)]="kymw2700Model.allKihanCopyCheck" [disabled]="kymw2700Model.chkAllKihanCopyDisabled"/>
              基版コピー</label>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="125" [header]="'状態'" [binding]="'ProgressStatus'" [align]="'left'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [align]="'left'">{{(cell.item.ProgressStatus === 'COMPLETE') ? '基版コピー済み' : '開始前'}}</div>
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>

<footer class="footer-buttons">
  <button id="btn_outputPagenation" #btn_outputPagenation class="btn-primary" (click)="eventBtnOutputCLICKHandler()"
    forcedEnabledMode="" [tabindex]="0">ページネーション情報出力</button>
</footer>